module.exports = __webpack_public_path__ + "static/img/262_TO8_2341.01473b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/262_TO8_2341.jpg
// module id = g2aj
// module chunks = 0